'use client'

import { usePathname } from 'next/navigation'

import { GR_VENDOR_BY_PATH } from '@/data/grVendors.js'
import { GR_VENDOR_CSS } from '@/data/grVendorCss.js'
import { openAuth } from '@/hooks/useAuthModal'

/*
 * 烘焙的廠商／玩法落地頁 —— 舊 WP 門面那套手刻版型(.tjwrap)原樣搬 React,退 WP 前置。
 * 這套版型自帶完整 CSS(全 scoped 在 .tjwrap 底下,不污染站台其餘),所以不走 ContentHtml
 * 的 .prose 文章樣式,而是掛 .tjwrap 容器 + 一次性注入共用 CSS。哪一個廠商由網址比對 grVendors.js。
 * 頁首／底部導覽已在抽取時砍掉(改用站台 React 殼 AppShell/BottomNav);麵包屑與內文連結保留。
 * 內文的「登入」CTA 是舊 WP 的 href=/action/?wp=login;AppShell 的 ?wp= 自動開窗 2026-10-22 已拿掉，
 * 所以這裡攔點擊直接開登入視窗（不然點了只會回首頁什麼都沒發生）。
 */
function onClick(e) {
  const a = e.target.closest?.('a[href*="wp=login"]')
  if (!a) return
  e.preventDefault()
  openAuth('login')
}
const norm = (p) => {
  let s = (p || '/').replace(/\/+$/, '') || '/'
  try {
    s = decodeURIComponent(s)
  } catch {
    // pathname 已是 decoded 形式就維持原樣
  }
  return s.toLowerCase()
}

export default function GrVendor() {
  const v = GR_VENDOR_BY_PATH[norm(usePathname())]
  if (!v) return null

  return (
    <div className="tjwrap">
      <style dangerouslySetInnerHTML={{ __html: GR_VENDOR_CSS }} />
      <div dangerouslySetInnerHTML={{ __html: v.html }} onClick={onClick} />
    </div>
  )
}
